import {
  HeartPulse, Utensils, Baby, HeartHandshake, Wallet, Leaf, Cloud, Sparkles,
  HandHeart, Compass, Stethoscope, Salad, Users, PiggyBank, Heart, PartyPopper,
} from "lucide-react";

// ── Resource categories (8) ──
export const CATEGORIES = [
  {
    slug: "health-wellness", title: "Health & Wellness", icon: HeartPulse,
    blurb: "Gentle, practical ways to care for your body and mind.",
    intro: "Caring for your body and mind doesn't have to be complicated. These are gentle, practical starting points for everyday wellbeing — no pressure, no perfection.",
    related: ["food-nutrition", "joy-growth"],
    accent: { tint: "#e9f0e6", deep: "#6f8f5c" },
    image: "https://images.unsplash.com/photo-1763004871583-4183d64096b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxjYWxtJTIwd2VsbG5lc3MlMjB5b2dhJTIwbWF0JTIwbW9ybmluZyUyMGxpZ2h0fGVufDB8fHx8MTc4NjUwMDY0Nnww&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "food-nutrition", title: "Food & Nutrition", icon: Utensils,
    blurb: "Everyday eating, without the pressure or perfection.",
    intro: "Food is fuel, comfort, and connection. Here's help for eating well in real life — flexible, affordable, and free of all-or-nothing rules.",
    related: ["health-wellness", "home-sustainable-living"],
    accent: { tint: "#f6ecdd", deep: "#c08a45" },
    image: "https://images.unsplash.com/photo-1658431618300-a69b07fb5782?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMHdob2xlc29tZSUyMGZvb2QlMjB3b29kZW4lMjB0YWJsZSUyMGxpbmVufGVufDB8fHx8MTc4NjUwMDY0N3ww&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "family-parenting", title: "Family & Parenting", icon: Baby,
    blurb: "For every season of caring for the people you love.",
    intro: "However you care for the people you love, it changes with every season. These guides meet you where you are, with warmth instead of judgment.",
    related: ["relationships", "grief-life-changes"],
    accent: { tint: "#e7eeec", deep: "#5c8a7e" },
    image: "https://images.unsplash.com/photo-1780561509223-82f3f8a0e8b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHBpY3R1cmUlMjBib29rcyUyMHdvb2RlbiUyMHRveXMlMjBjb3p5JTIwbm9va3xlbnwwfHx8fDE3ODY1MDIyNzd8MA&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "relationships", title: "Relationships", icon: HeartHandshake,
    blurb: "Connection, repair, and the courage to keep showing up.",
    intro: "Connection is built in small, repeated moments. Here's gentle support for showing up — for others and for yourself.",
    related: ["family-parenting", "joy-growth"],
    accent: { tint: "#f4e9e6", deep: "#b17a6b" },
    image: "https://images.unsplash.com/photo-1564020435666-f67ed5319a32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBob2xkaW5nJTIwaGFuZHMlMjB3YXJtJTIwY2FuZGlkfGVufDB8fHx8MTc4NjUwMDY0Nnww&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "work-money", title: "Work & Money", icon: Wallet,
    blurb: "Steadier days at work and a calmer relationship with money.",
    intro: "Work and money touch almost everything, yet we rarely talk about them kindly. These resources aim for steadier days and less quiet worry.",
    related: ["health-wellness", "home-sustainable-living"],
    accent: { tint: "#f2ecda", deep: "#a58a3c" },
    image: "https://images.unsplash.com/photo-1570841398791-33942bd1a99f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwZGVzayUyMGNvZmZlZSUyMG5vdGVib29rJTIwcGxhbnQlMjBjYWxtfGVufDB8fHx8MTc4NjUwMDY0Nnww&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "home-sustainable-living", title: "Home & Sustainable Living", icon: Leaf,
    blurb: "Small, kinder choices for your home and the planet.",
    intro: "Small, kinder choices for your space and the planet — practical, low-cost, and easy to keep up with over time.",
    related: ["food-nutrition", "joy-growth"],
    accent: { tint: "#e8f0e2", deep: "#6a9350" },
    image: "https://images.unsplash.com/photo-1626965654957-fef1cb80d4b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxzdW5saXQlMjBsaXZpbmclMjByb29tJTIwcGxhbnRzJTIwbGluZW4lMjBzdXN0YWluYWJsZXxlbnwwfHx8fDE3ODY1MDA2NDZ8MA&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "grief-life-changes", title: "Grief & Life Changes", icon: Cloud,
    blurb: "Companionship through loss, endings, and new beginnings.",
    intro: "Loss and change come to all of us. Here you'll find companionship for the hard middle — no timelines, no fixing, just care.",
    related: ["relationships", "health-wellness"],
    accent: { tint: "#eaedf1", deep: "#77808f" },
    image: "https://images.unsplash.com/photo-1544039161-b0c20826c6f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxxdWlldCUyMGNhbG0lMjBtaXN0eSUyMGZvcmVzdCUyMHBhdGh8ZW58MHx8fHwxNzg2NTAwNjQ2fDA&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
  {
    slug: "joy-growth", title: "Joy & Growth", icon: Sparkles,
    blurb: "Noticing the good and quietly becoming who you're growing into.",
    intro: "The good stuff counts too. These are gentle nudges toward noticing joy and quietly becoming who you're growing into.",
    related: ["health-wellness", "relationships"],
    accent: { tint: "#f7f0d8", deep: "#c9a02f" },
    image: "https://images.unsplash.com/photo-1620675506518-3df066bb2b30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxoYW5kcyUyMGhvbGRpbmclMjBncmVlbiUyMHNlZWRsaW5nJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg2NTAwNjQ2fDA&ixlib=rb-4.1.0&q=85&w=1200&fit=crop",
  },
];

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const relatedCategories = (slug) =>
  (categoryBySlug(slug)?.related || []).map(categoryBySlug).filter(Boolean);

// ── Reusable content types (visible labels) ──
export const CONTENT_TYPES = [
  { key: "explains", label: "HEARD Explains", note: "Clear, plain-language explainers." },
  { key: "learning", label: "What We're Learning", note: "Honest research summaries." },
  { key: "gentle-guide", label: "A Gentle Guide", note: "Step-by-step help, without pressure." },
  { key: "worth-asking", label: "Worth Asking", note: "Questions for reflection." },
  { key: "small-things", label: "Small Things That Help", note: "Tiny, doable actions." },
  { key: "encouragement", label: "Today's Encouragement", note: "A gentle reminder." },
  { key: "finds", label: "HEARD Finds", note: "Curated, editorial picks." },
];
export const typeLabel = (key) => CONTENT_TYPES.find((t) => t.key === key)?.label || key;
export const contentTypeByKey = (key) => CONTENT_TYPES.find((t) => t.key === key);

// Categories needing an educational disclaimer
const SENSITIVE = ["health-wellness", "food-nutrition", "work-money"];
export const needsDisclaimer = (categorySlug) => SENSITIVE.includes(categorySlug);

// ── Today at HEARD ──
export const TODAY = {
  affirmation: "You are allowed to move at the pace of your own healing.",
  kindness: "Send one honest message to someone you've been thinking about.",
  question: "What is one small thing that made today a little lighter?",
  practice: "Take three slow breaths and unclench your shoulders — you're doing enough.",
};

// ── Sample discussion prompts (safe, non-private) ──
export const COMMUNITY_PROMPTS = [
  "What's a small win you're proud of this week?",
  "What helped you get through a hard day recently?",
  "What's something you're learning to let go of?",
  "Who or what are you grateful for today?",
  "What does rest actually look like for you right now?",
];

// ── Example community spaces/topics (website introduction only) ──
export const COMMUNITY_SPACES = [
  { title: "Everyday Wins", note: "Celebrate the small stuff — a hard call made, a good night's sleep, a plant kept alive." },
  { title: "Just Venting", note: "A no-fixing zone to let it out. Sometimes you don't want advice — just to be heard." },
  { title: "Gentle Encouragement", note: "Ask for a boost, or leave one for a stranger who needs it today." },
  { title: "Life Transitions", note: "New jobs, new cities, new chapters — company for the in-between." },
  { title: "Caregivers' Corner", note: "For anyone looking after someone else, and quietly carrying a lot." },
  { title: "Small Joys", note: "Share the tiny things that made you smile. Joy is worth noticing out loud." },
];

// ── Explore by life moment (8) ──
export const LIFE_MOMENTS = [
  { label: "I'm caring for someone", icon: HandHeart, to: "/resources/family-parenting" },
  { label: "I'm starting over", icon: Compass, to: "/resources/grief-life-changes" },
  { label: "I'm worried about my health", icon: Stethoscope, to: "/resources/health-wellness" },
  { label: "I want to eat better", icon: Salad, to: "/resources/food-nutrition" },
  { label: "I'm feeling disconnected", icon: Users, to: "/resources/relationships" },
  { label: "I'm trying to save money", icon: PiggyBank, to: "/resources/work-money" },
  { label: "I need encouragement", icon: Heart, to: "/resources/joy-growth" },
  { label: "Something good happened", icon: PartyPopper, to: "/resources/joy-growth" },
];

// ── Resource library (16 across categories & content types) ──
// Article fields: whatKnow, stillLearning, everyday[], worthAsking[], sources[{title,org,date,url}]
// Discovery fields: tags[], featured, popular, addedAt (ISO date)
export let RESOURCES = [
  {
    slug: "understanding-everyday-stress",
    type: "explains", category: "health-wellness",
    title: "Understanding Everyday Stress",
    dek: "What stress actually is, why it shows up, and gentle ways to meet it.",
    readTime: "5 min", featured: true, popular: true, addedAt: "2026-01-15",
    tags: ["stress", "anxiety", "calm", "wellbeing", "nervous system", "overwhelm"],
    whatKnow:
      "Stress is the body's natural response to demand or change. In short bursts it can help us focus and rise to a challenge. When it becomes constant, it can affect sleep, mood, digestion, and how connected we feel to others.",
    stillLearning:
      "Researchers are still exploring why the same situation feels manageable for one person and overwhelming for another, and how factors like rest, relationships, and past experiences shape our response.",
    everyday: [
      "A few slow breaths before a hard conversation can settle the nervous system.",
      "Naming the feeling — 'I'm stressed because…' — often lowers its intensity.",
      "Tiny anchors (a walk, water, a text to a friend) matter more than one big fix.",
    ],
    worthAsking: [
      "What is my body trying to tell me right now?",
      "What is one thing I can set down this week?",
      "Who could I reach out to instead of carrying this alone?",
    ],
    sources: [
      { title: "Stress effects on the body", org: "American Psychological Association", date: "2023", url: "https://www.apa.org/topics/stress/body" },
      { title: "Stress", org: "World Health Organization", date: "2023", url: "https://www.who.int/news-room/questions-and-answers/item/stress" },
    ],
  },
  {
    slug: "what-were-learning-about-sleep",
    type: "learning", category: "health-wellness",
    title: "What We're Learning About Sleep",
    dek: "Rest is not a luxury. Here's what the research keeps pointing to.",
    readTime: "6 min", popular: true, addedAt: "2026-01-28",
    tags: ["sleep", "rest", "insomnia", "energy", "health", "research"],
    whatKnow:
      "Consistent, sufficient sleep supports memory, mood, immune function, and emotional regulation. Most adults do better with a regular wind-down and a stable sleep and wake time.",
    stillLearning:
      "The 'right' amount of sleep varies between people, and science is still untangling how light, stress, screens, and life stage interact with rest.",
    everyday: [
      "A calmer last hour (dim light, less screen) can help the body prepare for sleep.",
      "If you can't sleep, resting quietly still has value — it isn't wasted time.",
      "Be gentle with yourself after a bad night; one night rarely defines a season.",
    ],
    worthAsking: [
      "What does my wind-down routine look like tonight?",
      "Is there one thing keeping me up that I could write down and set aside?",
    ],
    sources: [
      { title: "About Sleep", org: "Centers for Disease Control and Prevention", date: "2024", url: "https://www.cdc.gov/sleep/about/index.html" },
      { title: "Sleep Deprivation and Deficiency", org: "National Heart, Lung, and Blood Institute (NIH)", date: "2022", url: "https://www.nhlbi.nih.gov/health/sleep-deprivation" },
    ],
  },
  {
    slug: "small-things-that-help-hard-day",
    type: "small-things", category: "joy-growth",
    title: "Small Things That Help on a Hard Day",
    dek: "When everything feels heavy, start impossibly small.",
    readTime: "3 min", popular: true, addedAt: "2026-02-10",
    tags: ["hard day", "overwhelm", "self-care", "small steps", "low mood"],
    whatKnow:
      "On difficult days, small, doable actions can gently shift how we feel — not by fixing everything, but by reminding us we can still take one step.",
    everyday: [
      "Drink a glass of water and open a window.",
      "Change one thing: clothes, room, or the song that's playing.",
      "Do the next tiny task, not the whole list.",
      "Tell one person, in one sentence, how you're really doing.",
    ],
    worthAsking: [
      "What would feel like kindness to myself in the next ten minutes?",
    ],
    sources: [],
  },
  {
    slug: "gentle-guide-talking-about-grief",
    type: "gentle-guide", category: "grief-life-changes",
    title: "A Gentle Guide to Talking About Grief",
    dek: "There's no perfect thing to say — presence matters more than words.",
    readTime: "5 min", addedAt: "2026-02-20",
    tags: ["grief", "loss", "support", "bereavement", "comfort"],
    whatKnow:
      "Grief is not a problem to solve; it's love with nowhere to go. People grieve in different ways and on different timelines, and there is no single 'right' path.",
    stillLearning:
      "We're still learning how culture, community, and ritual shape healthy grieving, and how best to support one another over the long term.",
    everyday: [
      "'I don't know what to say, but I'm here' is often enough.",
      "Offer specific help ('I'll bring dinner Tuesday') rather than 'let me know if you need anything.'",
      "Keep saying their loved one's name — most grieving people want them remembered.",
    ],
    worthAsking: [
      "How can I make space for this without trying to rush it?",
      "What would feel supportive — company, quiet, or practical help?",
    ],
    sources: [
      { title: "Supporting a Grieving Person", org: "Hospice Foundation of America", date: "2023", url: "https://hospicefoundation.org/" },
    ],
  },
  {
    slug: "eating-well-on-a-busy-week",
    type: "gentle-guide", category: "food-nutrition",
    title: "Eating Well on a Busy Week",
    dek: "Nourishing yourself when time and energy are short.",
    readTime: "4 min", addedAt: "2026-03-05",
    tags: ["nutrition", "meals", "busy", "food", "cooking", "energy"],
    whatKnow:
      "Balanced, regular meals help steady energy and mood. 'Good enough' nutrition on a busy week is far kinder — and more sustainable — than all-or-nothing rules.",
    stillLearning:
      "Nutrition science evolves, and individual needs differ. What works is often what you can realistically keep doing.",
    everyday: [
      "Keep a few easy 'anchor meals' you can make on autopilot.",
      "Pair something quick with something fresh — toast with fruit, soup with greens.",
      "Eating something is usually better than skipping and running on empty.",
    ],
    worthAsking: [
      "What's one easy meal I can prep ahead this week?",
      "Am I eating enough, and often enough, to feel steady?",
    ],
    sources: [
      { title: "The Nutrition Source", org: "Harvard T.H. Chan School of Public Health", date: "2024", url: "https://nutritionsource.hsph.harvard.edu/" },
    ],
  },
  {
    slug: "money-conversations-with-family",
    type: "worth-asking", category: "work-money",
    title: "Worth Asking: Money Conversations With Family",
    dek: "Talking about money with the people closest to us.",
    readTime: "4 min", popular: true, addedAt: "2026-03-12",
    tags: ["money", "family", "finance", "communication", "budget"],
    whatKnow:
      "Money is often tied to safety, values, and history — which is why these conversations feel loaded. Naming that upfront can lower the tension.",
    everyday: [
      "Choose a calm time, not a stressful one, to bring it up.",
      "Lead with shared goals ('I want us to feel less worried') rather than blame.",
      "Small, regular check-ins beat one big, high-stakes talk.",
    ],
    worthAsking: [
      "What do we each want money to make possible for our family?",
      "What's one money worry we could tackle together this month?",
      "What did we each learn about money growing up?",
    ],
    sources: [
      { title: "Talking about money", org: "Consumer Financial Protection Bureau", date: "2023", url: "https://www.consumerfinance.gov/" },
    ],
  },
  {
    slug: "reconnecting-when-you-feel-distant",
    type: "explains", category: "relationships",
    title: "Reconnecting When You Feel Distant",
    dek: "Closeness fades quietly — and it can be rebuilt the same way.",
    readTime: "5 min", addedAt: "2026-03-20",
    tags: ["relationships", "connection", "distance", "couples", "communication"],
    whatKnow:
      "Drifting apart is common and rarely means something is broken. Connection is built through small, repeated moments of attention far more than grand gestures.",
    everyday: [
      "Ask one curious question and really listen to the answer.",
      "Protect a small ritual — coffee, a walk, ten phone-free minutes.",
      "Repair after friction; a simple 'that came out wrong, can we try again?' goes far.",
    ],
    worthAsking: [
      "When did we last feel close, and what were we doing?",
      "What's one small moment of connection I can offer today?",
    ],
    sources: [
      { title: "Building connection", org: "The Gottman Institute", date: "2023", url: "https://www.gottman.com/" },
    ],
  },
  {
    slug: "caring-for-someone-you-love",
    type: "gentle-guide", category: "family-parenting",
    title: "Caring for Someone You Love",
    dek: "Looking after someone else without disappearing yourself.",
    readTime: "6 min", addedAt: "2026-03-28",
    tags: ["caregiving", "family", "burnout", "support", "care"],
    whatKnow:
      "Caregiving can be deeply meaningful and deeply tiring. Caregivers who accept help and tend to their own needs tend to sustain care longer and with more warmth.",
    stillLearning:
      "Support systems for caregivers are still catching up to the reality of how much they carry, often invisibly.",
    everyday: [
      "Let people help with specifics — a meal, a ride, an hour of relief.",
      "Schedule small breaks before you're running on empty.",
      "Your feelings — including frustration — are normal and don't make you a bad caregiver.",
    ],
    worthAsking: [
      "What support could I accept this week that I've been declining?",
      "What's one thing that refills me, even a little?",
    ],
    sources: [
      { title: "Taking Care of YOU: Self-Care for Family Caregivers", org: "Family Caregiver Alliance", date: "2023", url: "https://www.caregiver.org/" },
    ],
  },

  // ── Phase 2 additions ──
  {
    slug: "small-swaps-for-a-kinder-home",
    type: "small-things", category: "home-sustainable-living",
    title: "Small Swaps for a Kinder Home",
    dek: "Gentle, low-cost changes that are easier on your home and the planet.",
    readTime: "4 min", addedAt: "2026-04-08",
    tags: ["sustainable", "home", "eco", "cleaning", "waste", "swaps"],
    whatKnow:
      "Small, repeatable habits — using what you have, wasting less, choosing durable over disposable — add up over time. Sustainable living is less about perfection and more about steady, doable choices.",
    everyday: [
      "Keep a 'use it up' shelf so food and supplies don't get forgotten.",
      "Switch to a refillable or reusable version of one thing at a time.",
      "Air-dry laundry when you can; it's gentler on clothes and energy bills.",
      "Repair or repurpose before replacing.",
    ],
    worthAsking: [
      "What's one disposable item I could swap for a reusable one this month?",
      "What do I already own that could be reused instead of bought new?",
    ],
    sources: [
      { title: "Reduce, Reuse, Recycle", org: "U.S. Environmental Protection Agency", date: "2024", url: "https://www.epa.gov/recycle" },
    ],
  },
  {
    slug: "you-are-allowed-to-begin-again",
    type: "encouragement", category: "joy-growth",
    title: "You're Allowed to Begin Again",
    dek: "A gentle reminder for anyone starting over — at anything.",
    readTime: "2 min", featured: true, addedAt: "2026-04-18",
    tags: ["encouragement", "fresh start", "hope", "growth", "motivation"],
    whatKnow:
      "Beginnings don't have to be grand or perfectly timed. Most meaningful change starts quietly, with one small, imperfect step — and you're allowed to take it whenever you're ready.",
    everyday: [
      "A fresh start can begin on a Tuesday afternoon, not just January 1st.",
      "'Beginning again' counts even if you've begun many times before.",
      "Progress often looks like returning, not never falling.",
    ],
    worthAsking: [
      "What's one small thing I could gently begin again today?",
    ],
    sources: [],
  },
  {
    slug: "gentle-ways-to-move-more",
    type: "small-things", category: "health-wellness",
    title: "Gentle Ways to Move More",
    dek: "Movement that fits real life — no gym or grand plan required.",
    readTime: "3 min", featured: true, popular: true, addedAt: "2026-04-30",
    tags: ["movement", "exercise", "walking", "health", "energy", "body"],
    whatKnow:
      "Regular, gentle movement supports mood, energy, sleep, and heart health. It doesn't have to be intense or lengthy — consistency and enjoyment matter more than pushing hard.",
    stillLearning:
      "Researchers are still refining exactly how much and what kind of movement is 'optimal' for different bodies and life stages — but 'some movement, most days' is a well-supported starting point.",
    everyday: [
      "Take a short walk after a meal — even five minutes helps.",
      "Stretch while the kettle boils or during ad breaks.",
      "Pick movement you actually like; you'll do it more often.",
      "Count everyday activity — stairs, gardening, dancing in the kitchen.",
    ],
    worthAsking: [
      "What kind of movement feels good rather than like a punishment?",
      "Where could a few minutes of movement fit naturally into my day?",
    ],
    sources: [
      { title: "Physical Activity Guidelines for Americans", org: "U.S. Dept. of Health & Human Services", date: "2018", url: "https://health.gov/our-work/nutrition-physical-activity/physical-activity-guidelines" },
      { title: "Benefits of Physical Activity", org: "Centers for Disease Control and Prevention", date: "2023", url: "https://www.cdc.gov/physical-activity-basics/benefits/index.html" },
    ],
  },
  {
    slug: "what-were-learning-about-gut-health",
    type: "learning", category: "food-nutrition",
    title: "What We're Learning About Gut Health",
    dek: "The gut microbiome is a fast-moving field — here's what's steady and what's still forming.",
    readTime: "6 min", addedAt: "2026-05-10",
    tags: ["gut health", "microbiome", "fiber", "digestion", "food", "research"],
    whatKnow:
      "There's growing evidence that a varied, fiber-rich diet supports a diverse gut microbiome, which is linked to digestion and overall health. Whole foods, plants, and fermented foods are commonly highlighted.",
    stillLearning:
      "Much of the microbiome field is early and evolving. Many specific claims — especially about probiotics 'fixing' complex conditions — are not yet settled science. Be cautious of products promising dramatic results.",
    everyday: [
      "Aim for variety — different plants, not just more of one.",
      "Fiber-rich foods (beans, oats, fruit, veg) are a reliable, affordable start.",
      "Fermented foods like yogurt or kimchi may help, and are worth trying if you enjoy them.",
      "Big supplement claims deserve healthy skepticism.",
    ],
    worthAsking: [
      "Could I add one more plant-based food to my week?",
      "Am I evaluating gut-health products by evidence, or by marketing?",
    ],
    sources: [
      { title: "Your Digestive System", org: "National Institute of Diabetes and Digestive and Kidney Diseases (NIH)", date: "2022", url: "https://www.niddk.nih.gov/health-information/digestive-diseases" },
      { title: "The Nutrition Source: Fiber", org: "Harvard T.H. Chan School of Public Health", date: "2024", url: "https://nutritionsource.hsph.harvard.edu/carbohydrates/fiber/" },
    ],
  },
  {
    slug: "gentle-guide-to-your-first-budget",
    type: "gentle-guide", category: "work-money",
    title: "A Gentle Guide to Your First Budget",
    dek: "A calm, shame-free way to see where your money actually goes.",
    readTime: "5 min", popular: true, addedAt: "2026-05-20",
    tags: ["budget", "money", "saving", "finance", "spending", "planning"],
    whatKnow:
      "A budget is simply a plan for your money — not a test you pass or fail. Seeing income and spending clearly tends to reduce anxiety and helps small changes add up.",
    everyday: [
      "Start by tracking, not restricting — just watch where money goes for a month.",
      "Group spending into a few simple buckets (needs, wants, savings).",
      "Automate one small saving transfer so it happens without willpower.",
      "Revisit gently; budgets are meant to be adjusted, not obeyed perfectly.",
    ],
    worthAsking: [
      "What would 'enough' feel like for me each month?",
      "What's one small, painless change that would ease money stress?",
    ],
    sources: [
      { title: "Budgeting: How to create a budget", org: "Consumer Financial Protection Bureau", date: "2023", url: "https://www.consumerfinance.gov/consumer-tools/budgeting/" },
    ],
  },
  {
    slug: "screen-time-without-the-guilt",
    type: "explains", category: "family-parenting",
    title: "Screen Time Without the Guilt",
    dek: "What actually matters about kids and screens — beyond the fear headlines.",
    readTime: "5 min", popular: true, addedAt: "2026-05-30",
    tags: ["parenting", "screen time", "kids", "technology", "family", "children"],
    whatKnow:
      "Guidance has shifted from strict time limits toward the quality and context of screen use — what children watch, whether it's shared, and how it fits around sleep, movement, and connection.",
    stillLearning:
      "Research on screens and child development is ongoing and often nuanced; sweeping claims in either direction usually outrun the evidence.",
    everyday: [
      "Focus on content and context, not just the clock.",
      "Co-view when you can — it turns screens into shared time.",
      "Protect sleep and meals as screen-free where possible.",
      "Model the habits you hope to see; kids notice.",
    ],
    worthAsking: [
      "Is this screen time replacing something important, or supporting our day?",
      "What's one screen-free ritual we could protect as a family?",
    ],
    sources: [
      { title: "Media and Children", org: "American Academy of Pediatrics (HealthyChildren.org)", date: "2023", url: "https://www.healthychildren.org/English/family-life/Media/Pages/default.aspx" },
    ],
  },
  {
    slug: "what-were-learning-about-plants-and-indoor-air",
    type: "learning", category: "home-sustainable-living",
    title: "What We're Learning About Plants and Indoor Air",
    dek: "Houseplants are lovely — but what does the research really say about air quality?",
    readTime: "4 min", addedAt: "2026-06-08",
    tags: ["plants", "indoor air", "home", "air quality", "wellness", "research"],
    whatKnow:
      "Ventilation and reducing pollution sources are the most reliable ways to improve indoor air quality. Houseplants can boost mood and make a space feel calmer and more cared-for.",
    stillLearning:
      "Early lab studies suggested plants filter air, but real-home effects appear far smaller than headlines imply. The science here is still limited and often overstated.",
    everyday: [
      "Open windows when you can — fresh air is the simplest win.",
      "Keep plants for the joy and calm they bring, not as an air 'fix'.",
      "Reduce sources: dust, strong fragrances, and smoke matter more.",
      "A plant you can realistically keep alive beats an ambitious jungle.",
    ],
    worthAsking: [
      "What's one easy way to bring more fresh air into my space?",
      "Which plant would genuinely bring me joy to care for?",
    ],
    sources: [
      { title: "Indoor Air Quality (IAQ)", org: "U.S. Environmental Protection Agency", date: "2024", url: "https://www.epa.gov/indoor-air-quality-iaq" },
    ],
  },
  {
    slug: "worth-asking-reaching-out-to-an-old-friend",
    type: "worth-asking", category: "relationships",
    title: "Worth Asking: Reaching Out to an Old Friend",
    dek: "The quiet questions behind rekindling a friendship you miss.",
    readTime: "3 min", featured: true, addedAt: "2026-06-15",
    tags: ["friendship", "relationships", "connection", "reaching out", "reconnecting"],
    whatKnow:
      "People consistently underestimate how much others appreciate being reached out to. A simple, low-pressure message is usually welcomed far more than we fear.",
    everyday: [
      "Keep it light: 'You crossed my mind today and I wanted to say hi.'",
      "Let go of needing the perfect reason or a long explanation.",
      "No response isn't always rejection — timing and life get in the way.",
      "One small reconnection can matter more than you expect.",
    ],
    worthAsking: [
      "Who have I been meaning to reach out to but keep putting off?",
      "What's stopping me — and is it as true as it feels?",
    ],
    sources: [
      { title: "Undervaluing the positive impact of reaching out", org: "American Psychological Association (JPSP)", date: "2022", url: "https://www.apa.org/pubs/journals/psp" },
    ],
  },
  {
    slug: "gentle-guide-first-year-after-loss",
    type: "gentle-guide", category: "grief-life-changes",
    title: "A Gentle Guide to the First Year After a Loss",
    dek: "There's no right way to move through the first year — only your way.",
    readTime: "6 min", featured: true, addedAt: "2026-06-22",
    tags: ["grief", "loss", "first year", "bereavement", "healing", "anniversary"],
    whatKnow:
      "The first year after a loss often brings 'firsts' — first birthday, first holiday, first spring — that can reopen grief unexpectedly. This is normal, not a setback. Grief tends to come in waves rather than a steady line of improvement.",
    stillLearning:
      "There's no fixed timeline or set of 'stages' everyone passes through. Researchers increasingly see grief as unique to each person and relationship.",
    everyday: [
      "Let yourself brace gently for 'firsts' — plan softer, lighter days around them.",
      "Keep small anchors: a walk, a meal, a friend who checks in.",
      "Rituals — lighting a candle, visiting a place, saying their name — can help.",
      "It's okay to feel joy again; it isn't a betrayal of who you lost.",
    ],
    worthAsking: [
      "What kind of support do I actually want right now — company, quiet, or practical help?",
      "Which upcoming day might be tender, and how can I be gentle with myself around it?",
    ],
    sources: [
      { title: "Grief and Loss", org: "Centers for Disease Control and Prevention", date: "2023", url: "https://www.cdc.gov/mental-health/" },
      { title: "Supporting a Grieving Person", org: "Hospice Foundation of America", date: "2023", url: "https://hospicefoundation.org/" },
    ],
  },
  {
    slug: "worth-asking-supporting-someone-through-loss",
    type: "worth-asking", category: "grief-life-changes",
    title: "Worth Asking: Supporting Someone Through Loss",
    dek: "How to show up for a grieving friend without needing the perfect words.",
    readTime: "3 min", addedAt: "2026-06-24",
    tags: ["grief", "support", "friendship", "loss", "empathy", "comfort"],
    whatKnow:
      "Most grieving people don't need advice or fixing — they need to feel accompanied. Showing up consistently, in small ways, tends to matter more than saying something profound.",
    everyday: [
      "Offer specifics: 'I'll drop off dinner Thursday,' not 'let me know if you need anything.'",
      "Keep checking in weeks and months later, when others have moved on.",
      "It's okay to say 'I don't know what to say, but I'm here.'",
    ],
    worthAsking: [
      "Am I trying to fix their pain, or simply be with them in it?",
      "What small, concrete thing could I do this week to lighten their load?",
    ],
    sources: [
      { title: "Supporting a Grieving Person", org: "Hospice Foundation of America", date: "2023", url: "https://hospicefoundation.org/" },
    ],
  },
  {
    slug: "you-dont-grieve-on-a-timeline",
    type: "encouragement", category: "grief-life-changes",
    title: "You Don't Grieve on a Timeline",
    dek: "A gentle reminder for anyone who feels they 'should' be over it by now.",
    readTime: "2 min", addedAt: "2026-06-26",
    tags: ["grief", "encouragement", "healing", "patience", "self-compassion"],
    whatKnow:
      "There is no deadline for grief. It can soften and return, change shape, and surprise you years later — and none of that means you're doing it wrong. Love and loss don't run on a schedule.",
    everyday: [
      "You're allowed to still be grieving, however long it's been.",
      "You're also allowed to laugh, rest, and feel okay today.",
      "Comparison steals comfort — your grief is yours alone.",
    ],
    worthAsking: [
      "Can I offer myself the same patience I'd offer a grieving friend?",
    ],
    sources: [],
  },
  {
    slug: "small-things-that-help-when-starting-over",
    type: "small-things", category: "grief-life-changes",
    title: "Small Things That Help When Starting Over",
    dek: "New city, new chapter, new normal — tiny footholds for the in-between.",
    readTime: "3 min", popular: true, addedAt: "2026-06-28",
    tags: ["life transition", "starting over", "change", "new city", "fresh start", "adjustment"],
    whatKnow:
      "Big transitions can feel disorienting even when they're good. Re-establishing small routines and one or two points of connection helps the ground feel steadier while the rest catches up.",
    everyday: [
      "Rebuild one daily anchor first — a morning coffee, a walk, a bedtime.",
      "Find a single 'third place': a café, library, class, or park you return to.",
      "Reach out to one person a week; connection rarely rebuilds by accident.",
      "Give yourself a season, not a weekend, to feel at home.",
    ],
    worthAsking: [
      "What one small routine would help me feel more like myself here?",
      "Where could I keep showing up until it starts to feel familiar?",
    ],
    sources: [],
  },
  {
    slug: "gentle-guide-simple-gratitude-practice",
    type: "gentle-guide", category: "joy-growth",
    title: "A Gentle Guide to a Simple Gratitude Practice",
    dek: "Not toxic positivity — just quietly noticing what's already good.",
    readTime: "4 min", addedAt: "2026-06-30",
    tags: ["gratitude", "joy", "wellbeing", "reflection", "habits", "growth"],
    whatKnow:
      "Regularly noticing small good things is associated with improved mood and wellbeing for many people. It works best as a gentle habit, not a demand to feel grateful when you don't.",
    stillLearning:
      "Gratitude isn't a cure-all, and forcing it can backfire. It sits alongside — not instead of — honouring hard feelings.",
    everyday: [
      "Name three small specifics at night — the coffee, the text, the sky.",
      "Keep it tiny and real; 'I'm grateful for a warm bed' counts.",
      "Skip a day without guilt — this is a practice, not a test.",
    ],
    worthAsking: [
      "What small, ordinary thing made today a little better?",
      "Who could I thank, out loud, this week?",
    ],
    sources: [
      { title: "Gratitude and Wellbeing", org: "Greater Good Science Center, UC Berkeley", date: "2023", url: "https://greatergood.berkeley.edu/topic/gratitude" },
    ],
  },
  {
    slug: "small-things-that-ease-money-worry",
    type: "small-things", category: "work-money",
    title: "Small Things That Ease Money Worry",
    dek: "Tiny, doable steps for when money stress is loud.",
    readTime: "3 min", addedAt: "2026-07-02",
    tags: ["money", "finance", "stress", "budget", "saving", "anxiety"],
    whatKnow:
      "Money worry often grows in the unknown. Small acts of clarity and control — even tiny ones — can quiet some of the anxiety, even before the numbers change.",
    everyday: [
      "Look at one account instead of avoiding them all — clarity lowers dread.",
      "Automate one small saving or bill so it's one less thing to hold.",
      "Name your top money worry out loud or on paper; it often shrinks a little.",
      "Ask about options early — many providers have hardship or payment plans.",
    ],
    worthAsking: [
      "What's one small money task I've been avoiding that I could do today?",
      "Who could I talk to honestly about this instead of carrying it alone?",
    ],
    sources: [
      { title: "Managing financial stress", org: "Consumer Financial Protection Bureau", date: "2023", url: "https://www.consumerfinance.gov/" },
    ],
  },
  {
    slug: "worth-asking-setting-kind-boundaries",
    type: "worth-asking", category: "relationships",
    title: "Worth Asking: Setting Kind Boundaries",
    dek: "Boundaries aren't walls — they're how we keep relationships honest and warm.",
    readTime: "4 min", addedAt: "2026-07-04",
    tags: ["boundaries", "relationships", "family", "communication", "self-care", "wellbeing"],
    whatKnow:
      "Healthy boundaries protect relationships rather than end them. Said with warmth and clarity, a boundary is a form of care — for you and the other person.",
    everyday: [
      "Be specific and kind: 'I can't talk after 9pm, but I'd love to tomorrow.'",
      "You can hold a boundary and still love someone.",
      "Guilt is common at first — it doesn't mean you're doing something wrong.",
    ],
    worthAsking: [
      "Where am I saying yes when I mean no — and what is it costing me?",
      "What's one small boundary that would give me more energy for the people I love?",
    ],
    sources: [
      { title: "Setting healthy boundaries", org: "American Psychological Association", date: "2023", url: "https://www.apa.org/topics/healthy-workplaces/boundaries" },
    ],
  },

  // ── Phase 5 additions ──
  {
    slug: "understanding-burnout",
    type: "explains", category: "health-wellness",
    title: "Understanding Burnout",
    dek: "What burnout actually is, how it creeps in, and gentle first steps toward recovery.",
    readTime: "5 min", featured: true, addedAt: "2026-07-06",
    tags: ["burnout", "stress", "exhaustion", "wellbeing", "rest", "work"],
    whatKnow:
      "Burnout is more than being tired — it's a state of emotional, mental, and often physical exhaustion caused by prolonged stress. It commonly shows up as depletion, cynicism or detachment, and a sense that nothing you do is enough. It builds slowly, which is part of why it's easy to miss.",
    stillLearning:
      "Researchers are still mapping exactly where ordinary stress ends and burnout begins, and how workplace, caregiving, and personal factors interact. Recovery looks different for different people.",
    everyday: [
      "Notice the early signs — dread, numbness, or losing joy in things you used to like.",
      "Protect one genuine rest window, even a short one, before you hit empty.",
      "Recovery usually needs changed demands, not just a weekend off.",
      "Reaching out — to a friend, a doctor, or a manager — is a strength, not a failure.",
    ],
    worthAsking: [
      "What's draining me most right now, and is any of it something I can set down?",
      "Who could I be honest with about how depleted I feel?",
    ],
    sources: [
      { title: "Burn-out an 'occupational phenomenon'", org: "World Health Organization", date: "2019", url: "https://www.who.int/news/item/28-05-2019-burn-out-an-occupational-phenomenon-international-classification-of-diseases" },
      { title: "Stress effects on the body", org: "American Psychological Association", date: "2023", url: "https://www.apa.org/topics/stress/body" },
    ],
  },
  {
    slug: "gentle-guide-grocery-shopping-on-a-budget",
    type: "gentle-guide", category: "food-nutrition",
    title: "A Gentle Guide to Grocery Shopping on a Budget",
    dek: "Eating well when money is tight — without shame or complicated rules.",
    readTime: "5 min", popular: true, addedAt: "2026-07-08",
    tags: ["groceries", "budget", "food", "nutrition", "saving", "meals"],
    whatKnow:
      "Nourishing food doesn't have to be expensive. Simple staples — beans, grains, frozen vegetables, eggs, seasonal produce — offer strong nutrition for the cost, and a loose plan tends to cut waste and stress.",
    stillLearning:
      "Food access and prices vary widely by place and season, so the 'best' budget approach is the one that fits your kitchen, time, and what's available near you.",
    everyday: [
      "Plan a few meals around what's on offer, not the other way around.",
      "Frozen and canned fruit and veg count — they're affordable and last.",
      "A short list (and a snack before you shop) helps avoid impulse spending.",
      "Cook once, eat twice — leftovers stretch both food and energy.",
    ],
    worthAsking: [
      "What three affordable staples could anchor most of my meals this week?",
      "Where does food tend to go to waste for me, and how could I catch it sooner?",
    ],
    sources: [
      { title: "Healthy Eating on a Budget", org: "U.S. Department of Agriculture (MyPlate)", date: "2024", url: "https://www.myplate.gov/eat-healthy/healthy-eating-budget" },
      { title: "The Nutrition Source", org: "Harvard T.H. Chan School of Public Health", date: "2024", url: "https://nutritionsource.hsph.harvard.edu/" },
    ],
  },
  {
    slug: "worth-asking-asking-for-what-you-need-at-work",
    type: "worth-asking", category: "work-money",
    title: "Worth Asking: Asking for What You Need at Work",
    dek: "How to name what would help — support, flexibility, or a fairer load — without dread.",
    readTime: "4 min", addedAt: "2026-07-10",
    tags: ["work", "communication", "boundaries", "career", "advocacy", "stress"],
    whatKnow:
      "Most needs at work go unspoken because asking feels risky. But clear, specific, calmly-framed requests are far more likely to be understood — and met — than hints or quiet resentment.",
    everyday: [
      "Name the need and the why: 'To do this well, I'd need X.'",
      "Ask for something specific and doable, not a vague 'more support.'",
      "Pick a calm moment, and put bigger asks in writing so they're easy to revisit.",
      "A 'no' is information, not the end — it often opens a smaller yes.",
    ],
    worthAsking: [
      "What's one thing that would genuinely make my work more sustainable?",
      "What am I afraid will happen if I ask — and how likely is that, really?",
    ],
    sources: [
      { title: "Healthy workplaces and boundaries", org: "American Psychological Association", date: "2023", url: "https://www.apa.org/topics/healthy-workplaces/boundaries" },
    ],
  },
  {
    slug: "small-ways-to-add-more-play",
    type: "small-things", category: "joy-growth",
    title: "Small Ways to Add More Play to Your Week",
    dek: "Play isn't just for kids — it's a quiet source of energy and joy.",
    readTime: "3 min", addedAt: "2026-07-12",
    tags: ["play", "joy", "fun", "creativity", "rest", "growth"],
    whatKnow:
      "Playfulness — doing something purely because it's enjoyable — is linked to lower stress and more connection. It doesn't need special time or money; it needs permission.",
    everyday: [
      "Do one small thing with no goal attached — a doodle, a silly song, a game.",
      "Say yes to a little spontaneity: a different route, a new recipe, a dance break.",
      "Play with others when you can; shared laughter deepens connection.",
      "Follow curiosity for ten minutes without needing to be good at it.",
    ],
    worthAsking: [
      "What did I love doing as a kid that I could bring back, even briefly?",
      "Where could ten minutes of pure fun fit into my week?",
    ],
    sources: [],
  },
  {
    slug: "making-new-friends-as-an-adult",
    type: "explains", category: "relationships",
    title: "Making New Friends as an Adult",
    dek: "Why adult friendship feels harder — and gentle ways to build it anyway.",
    readTime: "5 min", popular: true, addedAt: "2026-07-14",
    tags: ["friendship", "connection", "loneliness", "relationships", "community", "belonging"],
    whatKnow:
      "Friendship in adulthood usually grows from repeated, low-pressure contact rather than instant chemistry. Without school or shared routines, it takes a little more intention — which is normal, not a personal failing.",
    everyday: [
      "Show up regularly somewhere — a class, a group, a volunteer shift.",
      "Move a friendly acquaintance forward with a specific invite.",
      "Be the one who follows up; most people are relieved when someone does.",
      "Lower the bar — a short walk or coffee counts as connection.",
    ],
    worthAsking: [
      "Who have I clicked with lately that I could invite to something small?",
      "What regular activity would put me near the kind of people I'd like to know?",
    ],
    sources: [
      { title: "Manage stress: Strengthen your support network", org: "American Psychological Association", date: "2022", url: "https://www.apa.org/topics/stress/manage-social-support" },
    ],
  },
  {
    slug: "small-ways-to-make-your-home-feel-calmer",
    type: "small-things", category: "home-sustainable-living",
    title: "Small Ways to Make Your Home Feel Calmer",
    dek: "Tiny, low-cost changes that help your space feel like a place to breathe.",
    readTime: "3 min", addedAt: "2026-07-16",
    tags: ["home", "calm", "declutter", "space", "wellbeing", "environment"],
    whatKnow:
      "Our surroundings quietly shape how we feel. Small tweaks — light, order, and a few things you love — can make a home feel more restful without a big project or budget.",
    everyday: [
      "Clear one surface you see often; a little order lowers background stress.",
      "Let in natural light during the day and soften it at night.",
      "Keep one 'calm corner' — a chair, a plant, a lamp — that's just for resting.",
      "Reset for five minutes before bed so mornings start gentler.",
    ],
    worthAsking: [
      "Which spot in my home would help most if it felt calmer?",
      "What's one small thing I could clear, add, or soften today?",
    ],
    sources: [],
  },
  {
    slug: "small-things-that-help-after-a-big-move",
    type: "small-things", category: "grief-life-changes",
    title: "Small Things That Help After a Big Move",
    dek: "Finding your footing when everything around you is new.",
    readTime: "3 min", addedAt: "2026-07-18",
    tags: ["moving", "life transition", "new city", "change", "adjustment", "belonging"],
    whatKnow:
      "A move reshuffles almost every routine at once, which is tiring even when the move is happy. Rebuilding a few small anchors and one or two connections helps the new place start to feel like home.",
    everyday: [
      "Unpack the things that make a space feel like yours first — not just the essentials.",
      "Find one nearby 'regular' — a café, park, shop, or route you return to.",
      "Introduce yourself to one neighbour or join one local group.",
      "Give yourself a full season to settle before judging how it's going.",
    ],
    worthAsking: [
      "What small routine would help me feel more like myself here?",
      "Where could I keep showing up until this place feels familiar?",
    ],
    sources: [],
  },
];
const STATIC_RESOURCES = RESOURCES.slice();
export const applyPublishedResources = (dbList) => {
  const map = new Map(STATIC_RESOURCES.map((r) => [r.slug, r]));
  (dbList || []).forEach((d) => {
    if (d && d.slug && d.status === "published") map.set(d.slug, { ...(map.get(d.slug) || {}), ...d });
  });
  RESOURCES = Array.from(map.values());
};
export const resourceBySlug = (slug) => RESOURCES.find((r) => r.slug === slug);
export const resourcesByCategory = (slug) => RESOURCES.filter((r) => r.category === slug);
export const resourcesByType = (key) => RESOURCES.filter((r) => r.type === key);
export const featuredResources = () => RESOURCES.filter((r) => r.featured);
export const popularResources = () => RESOURCES.filter((r) => r.popular);
export const recentResources = (n = 4) =>
  [...RESOURCES].sort((a, b) => (b.addedAt || "").localeCompare(a.addedAt || "")).slice(0, n);
export const resourcesByTag = (tag) => RESOURCES.filter((r) => (r.tags || []).includes(tag));
export const relatedResources = (resource, n = 3) =>
  RESOURCES.filter(
    (r) => r.slug !== resource.slug && (r.category === resource.category || r.type === resource.type)
  ).slice(0, n);

// Rich searchable string for a resource (title, dek, category, type, tags)
export const searchIndex = (r) =>
  [r.title, r.dek, categoryBySlug(r.category)?.title || "", typeLabel(r.type), (r.tags || []).join(" ")]
    .join(" ")
    .toLowerCase();

// ── HEARD Finds (curated, editorial — future-ready, no affiliate logic) ──
export const FIND_GROUPS = [
  { key: "books", label: "Books & Reading" },
  { key: "comfort", label: "Home & Everyday Comfort" },
  { key: "food-kitchen", label: "Food & Kitchen" },
  { key: "wellness", label: "Wellness & Self-Care" },
  { key: "earth", label: "Earth-Friendly Living" },
  { key: "tools", label: "Helpful Tools & Resources" },
];

// ── HEARD Finds disclosure standards (prepared, INACTIVE) ──────────────
// These labels + language exist so future monetization can be added transparently
// WITHOUT changing page structure. Nothing is monetized yet, so no label is shown
// unless a Find explicitly sets `label` / `sponsored` / `affiliateDisclosure`.
export const FIND_LABELS = {
  pick: { key: "pick", text: "HEARD Pick", tone: "#6f8f5c" },        // editorial default (not a monetization label)
  partner: { key: "partner", text: "Partner", tone: "#5c8a7e" },
  sponsored: { key: "sponsored", text: "Sponsored", tone: "#c08a45" },
  affiliate: { key: "affiliate", text: "Affiliate Link", tone: "#b17a6b" },
};
export const FINDS_GENERAL_DISCLOSURE =
  "Every HEARD Find is chosen editorially by our team — there are no paid placements, sponsored rankings, or checkout here. " +
  "In the future, HEARD may earn a small commission from some recommended links, and we may occasionally partner with brands we trust. " +
  "If that ever happens, we'll clearly label anything sponsored or affiliated. Either way, our recommendations stay independently selected — " +
  "we only share things we'd feel good passing to a friend.";
// Returns the disclosure label to display for a Find, or null when it isn't monetized.
export const findLabel = (find) => {
  if (!find) return null;
  if (find.affiliateDisclosure || find.affiliate) return FIND_LABELS.affiliate;
  if (find.sponsored) return FIND_LABELS.sponsored;
  if (find.partner) return FIND_LABELS.partner;
  return null; // editorial-only finds carry no monetization label
};

// Each find is future-ready: `partner`, `link`, `affiliateDisclosure`, and
// `sponsored` can be populated later WITHOUT changing the page structure.
// For now they stay editorial-only (non-commercial): partner/link null, sponsored false.
// `why` is the editorial reason HEARD selected it; `image` is people-free imagery.
const mkFind = (group, tag, title, note, why, image, link = null) => ({
  group, tag, title, note, why, image, link,
  partner: null, affiliateDisclosure: null, sponsored: false,
});

export let FINDS = [
  // ── Books & Reading ──
  mkFind("books", "Reading", "A gratitude journal we like", "Low-pressure prompts for noticing the good.", "Gentle structure makes a gratitude habit easier to keep.", "https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("books", "Reading", "\u201CAtlas of the Heart\u201D by Bren\u00E9 Brown", "A warm map of human emotions and connection.", "It gives helpful language for feelings that are hard to name.", "https://images.unsplash.com/photo-1603058817990-2b9a9abbce86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("books", "Reading", "\u201CThe Comfort Book\u201D by Matt Haig", "Short, kind reflections for heavier days.", "Bite-sized comfort you can open to any page when you need a lift.", "https://images.unsplash.com/photo-1625053376622-e462848c453f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),

  // ── Home & Everyday Comfort ──
  mkFind("comfort", "Home", "A warm, weighted blanket", "Gentle, grounding comfort on anxious evenings.", "Many people find the gentle weight soothing when they're wound up.", "https://images.unsplash.com/photo-1674475760738-8c7af859f821?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("comfort", "Home", "A sunrise-style alarm", "A softer way to wake than a blaring phone.", "A kinder start to the day can set a calmer tone.", "https://images.unsplash.com/photo-1586801199339-3de994fcf442?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("comfort", "Everyday", "A pocket notebook for brain-dumps", "Somewhere to park worries and to-dos before bed.", "Getting it out of your head and onto paper eases the mental load.", "https://images.unsplash.com/photo-1620275765334-4ed948bb4502?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),

  // ── Food & Kitchen ──
  mkFind("food-kitchen", "Food", "Budget-friendly batch recipes", "Freezer-friendly meals for busy weeks.", "Cooking once and eating twice protects time and energy.", "https://images.unsplash.com/photo-1559837957-bab8edc53c85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("food-kitchen", "Kitchen", "A good reusable water bottle", "The simplest nudge to drink a little more water.", "Keeping it in sight is a low-effort way to stay hydrated.", "https://images.unsplash.com/photo-1605714312496-01e90cb509cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("food-kitchen", "Kitchen", "A simple slow cooker", "Set it in the morning, come home to a warm meal.", "It quietly takes one decision off the hardest days.", "https://images.unsplash.com/photo-1650917585381-ab50c6dd5720?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),

  // ── Wellness & Self-Care ──
  mkFind("wellness", "Wellness", "A calming evening tea ritual", "A simple wind-down idea for hard-to-settle nights.", "A tiny ritual that signals to your body it's safe to slow down.", "https://images.unsplash.com/photo-1759356864682-245962aa980b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("wellness", "Wellness", "A small essential-oil diffuser", "A soft, calming scent for your space.", "Scent can gently cue the mind that it's time to rest.", "https://images.unsplash.com/photo-1768471569643-717e823b5f9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("wellness", "Self-care", "A short guided-breathing habit", "A few minutes of slow breathing, most days.", "Slow breathing is one of the simplest ways to settle the nervous system.", "https://images.unsplash.com/photo-1782197363071-dd70a9930809?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),

  // ── Earth-Friendly Living ──
  mkFind("earth", "Sustainable", "Reusable beeswax food wraps", "A small swap away from single-use plastic.", "An easy, low-cost first step toward less waste.", "https://images.unsplash.com/photo-1633878353697-f751870d1d76?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("earth", "Sustainable", "Refillable cleaning tablets", "Less plastic under the sink, same clean home.", "Refills cut plastic without asking you to change your routine.", "https://images.unsplash.com/photo-1621496654772-c66c48290259?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),

  // ── Helpful Tools & Resources ──
  mkFind("tools", "Resource", "A free local library card", "Books, audiobooks, and often free courses — at no cost.", "One of the most underrated free resources for everyday life.", "https://images.unsplash.com/photo-1620130674275-d709994ed7c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop"),
  mkFind("tools", "Support", "988 Suicide & Crisis Lifeline (US)", "Free, confidential support, 24/7, if things ever feel too heavy.", "Because everyone deserves somewhere to turn on the hardest days.", "https://images.unsplash.com/photo-1722222783504-d1d5f1ec76c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&fit=crop", "https://988lifeline.org/"),
];
const STATIC_FINDS = FINDS.slice();
export const applyPublishedFinds = (dbList) => {
  const extra = (dbList || []).filter((f) => f && f.status === "published");
  FINDS = [...STATIC_FINDS, ...extra];
};
export const findsByGroup = (key) => FINDS.filter((f) => f.group === key);

// ── Editorial page photography (one strong image per major page) ──
export const PAGE_IMAGES = {
  explore: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxlbGV2YXRlZCUyMG5ldXRyYWwlMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBkYXlsaWdodHxlbnwwfHx8fDE3ODY1MDA2NDZ8MA&ixlib=rb-4.1.0&q=85&w=1400&fit=crop",
  resources: "https://images.unsplash.com/photo-1764346855688-40ddc091f9c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb3p5JTIwbmV1dHJhbCUyMHdlbGxuZXNzJTIwaG9tZSUyMHdhcm0lMjB0ZWF8ZW58MHx8fHwxNzg2NTAwNjIwfDA&ixlib=rb-4.1.0&q=85&w=1400&fit=crop",
  learning: "https://images.unsplash.com/photo-1775129667554-1ba0db7fabe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3b29kZW4lMjBkZXNrJTIwb3BlbiUyMGJvb2tzJTIwc29mdCUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3ODY1MDA2MjB8MA&ixlib=rb-4.1.0&q=85&w=1400&fit=crop",
  finds: "https://images.unsplash.com/photo-1633856859910-ab62d9cf10c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxuZXV0cmFsJTIwZmxhdCUyMGxheSUyMGNlcmFtaWNzJTIwbGluZW4lMjBzdGlsbCUyMGxpZmV8ZW58MHx8fHwxNzg2NTAwNjIwfDA&ixlib=rb-4.1.0&q=85&w=1400&fit=crop",
  community: "https://images.unsplash.com/photo-1625283518288-00362afc8663?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwbXVsdGljdWx0dXJhbCUyMGZyaWVuZHMlMjBsYXVnaGluZyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc4NjUwMjI3N3ww&ixlib=rb-4.1.0&q=85&w=1400&fit=crop",
};

// ── Community Stories (real-life HEARD stories, shared with permission) ──
// Reusable format: add an object here, or publish via /admin. DB stories merge below.
export let COMMUNITY_STORIES = [
  {
    slug: "supporting-troy",
    title: "When Someone You Love Is Facing Cancer",
    subtitle: "Supporting Troy through treatment, family, and community",
    subject: "Troy, 37",
    excerpt: "A HEARD Community Story about family, support, and showing up when life changes quickly.",
    image: "/troy-real.jpg",
    intro:
      "Troy, 37, is facing advanced lung cancer and preparing for treatment. His family is surrounding him with love, practical support, and hope while he focuses on getting better.",
    sections: [
      {
        heading: "When life changes quickly",
        body: [
          "A serious diagnosis rarely stays in one place. Almost overnight it can touch far more than health — work, finances, transportation, family routines, and the small, ordinary rhythms of everyday life.",
          "For Troy and his family, the days now hold appointments, decisions, and a lot of unknowns. In moments like these, steady support from the people around you can make an enormous difference.",
        ],
      },
      {
        heading: "What showing up can look like",
        body: "Support doesn't have to be grand. Often it's the small, consistent things that carry someone through:",
        bullets: [
          "Checking in — a simple message that asks nothing in return",
          "Helping with meals, or dropping off something warm",
          "Offering transportation to and from appointments",
          "Running practical errands so the family has one less thing to hold",
          "Emotional support — listening without trying to fix",
          "Respecting someone's need for space and rest",
          "Sharing encouragement and small reminders that they're not alone",
        ],
      },
      {
        heading: "Supporting Troy",
        body: [
          "Troy is part of the extended HEARD family. Anyone who feels moved to help can support him and his family directly through his GoFundMe.",
          "Every bit of encouragement — a donation, a share, or simply a kind word — helps Troy focus on what matters most right now: getting better, surrounded by people who care.",
        ],
      },
    ],
    support: {
      name: "Support Troy",
      url: "https://gofund.me/troy-rock-10aug",
      qr: "/troy-gofundme-qr.png",
      note:
        "Shared with Troy's permission. HEARD is sharing this story as part of our community storytelling. Donations are processed independently through GoFundMe.",
    },
    publishedAt: "2026-08-12",
    status: "published",
  },
];
const STATIC_STORIES = COMMUNITY_STORIES.slice();
export const applyPublishedStories = (dbList) => {
  const extra = (dbList || [])
    .filter((s) => s && s.status === "published" && s.slug)
    .map((s) => ({
      ...s,
      support: {
        name: s.support_name || "Support",
        url: s.support_url || "",
        note: s.support_note || "",
      },
      // DB stories use a single body field -> render as one "The story" section
      sections: s.body ? [{ heading: "The story", body: String(s.body).split("\n").filter(Boolean) }] : [],
    }));
  const staticSlugs = new Set(STATIC_STORIES.map((s) => s.slug));
  COMMUNITY_STORIES = [...STATIC_STORIES, ...extra.filter((s) => !staticSlugs.has(s.slug))];
};
export const communityStoryBySlug = (slug) => COMMUNITY_STORIES.find((s) => s.slug === slug);
